<template>
  <aside v-if="hasOwnedDigitalAssets" class="owned-nfts">
    <div class="owned-nfts__header">
      <Paragraph class="font-jost-regular text-blue-dark text-[25px] leading-[30px]" text="Owned Digital Assets" />
      <span class="owned-nfts__count">{{ nfts.length }}</span>
    </div>

    <ul class="owned-nfts__list">
      <li v-for="nft in nfts" :key="getNftKey(nft)" class="owned-nfts__item">
        <span class="owned-nfts__label">Digital Asset ID</span>
        <router-link
          v-if="getNftHash(nft)"
          :to="{ name: 'nft', params: { chainNumber: getNftChainNumber(nft), nftId: getNftHash(nft) } }"
          class="owned-nfts__hash"
          :title="getNftHash(nft)"
        >
          {{ getShortHash(getNftHash(nft)) }}
        </router-link>
      </li>
    </ul>
  </aside>
</template>

<script>
import api from '@/helpers/api';
import Paragraph from '@/components/web/ParagraphComponent';

export default {
  name: 'OwnedNftsPanel',
  components: {
    Paragraph,
  },
  props: {
    accountAddress: {
      type: String,
      required: true,
    },
    chainNumber: {
      type: [Number, String],
      default: undefined,
    },
  },
  data() {
    return {
      nfts: [],
    };
  },
  computed: {
    hasOwnedDigitalAssets() {
      return this.nfts.length > 0;
    },
  },
  created() {
    this.fetchOwnedNfts();
  },
  watch: {
    accountAddress() {
      this.fetchOwnedNfts();
    },
    chainNumber() {
      this.fetchOwnedNfts();
    },
  },
  methods: {
    fetchOwnedNfts() {
      if (!this.accountAddress) {
        this.nfts = [];
        return;
      }

      this.nfts = [];

      api.getOwnedNftsForAccount(this.accountAddress, this.normalizedChainNumber())
        .then((res) => {
          this.nfts = this.normalizeNfts(res.data);
        })
        .catch(() => {
          this.nfts = [];
        });
    },
    normalizeNfts(data) {
      const result = data?.result;

      if (Array.isArray(result)) return result;

      return [];
    },
    normalizedChainNumber() {
      if (this.chainNumber === undefined || this.chainNumber === null || this.chainNumber === '') {
        return undefined;
      }

      const value = Number(this.chainNumber);
      return Number.isNaN(value) ? undefined : value;
    },
    getNftHash(nft) {
      if (typeof nft === 'string') {
        return nft;
      }

      return nft.accountNumApp || nft.hash || nft.nftId || '';
    },
    getNftChainNumber(nft) {
      if (typeof nft === 'string') {
        return this.normalizedChainNumber();
      }

      return nft.chainNumber || this.normalizedChainNumber();
    },
    getNftKey(nft) {
      return `${this.getNftHash(nft)}-${this.getNftChainNumber(nft) || ''}`;
    },
    getShortHash(hash) {
      return hash;
    },
  },
};
</script>

<style scoped>
.owned-nfts {
  width: 600px;
}

.owned-nfts__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 11px;
}

.owned-nfts__count {
  min-width: 36px;
  padding: 2px 10px;
  border-radius: 999px;
  background: #ffffff;
  color: #2A4067;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
}

.owned-nfts__list {
  max-height: 235px;
  border-radius: 9px;
  background: #ffffff;
  overflow-y: auto;
  padding: 10px;
}

.owned-nfts__item {
  padding: 10px 8px;
  border-bottom: 1px solid #D1EBFF;
}

.owned-nfts__item:last-child {
  border-bottom: 0;
}

.owned-nfts__label {
  display: block;
  margin-bottom: 4px;
  color: #2A4067;
  font-size: 14px;
  line-height: 19px;
}

.owned-nfts__hash {
  display: block;
  color: #0095C5;
  font-size: 16px;
  line-height: 21px;
  overflow-wrap: anywhere;
}

.owned-nfts__meta {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 4px;
  color: #2A4067;
  font-size: 13px;
  line-height: 18px;
}

@media (max-width: 1200px) {
  .owned-nfts {
    width: 100%;
    max-width: 676px;
  }
}
</style>
